export const CommentDistributionGraph = () => {
  return <div></div>;
};
